import React from "react";
var __jsx = React.createElement;
import stl from "./HomePage.module.css";
import { useTranslation } from "@i18n";
import "react-lazy-load-image-component/src/effects/blur.css";
import LazyLoadComponent from "@hooks/LazyLoadComponent";
import loadable from "@loadable/component";
import useHelpers from "@hooks/useHelpers";
import { checkFeatureFlag } from "@/common/config/websiteConfig";
import useIsMobile from "@hooks/useIsMobile";
import { useRecentlyViewedContext } from "@/_MiniApps/RecentlyViewedContext/RecentlyViewedContext";
import HomeBanner from "@/pages/homePageV2/homePageComponents/components/HomeBanner/HomeBanner";
import UnbxdTextSearch from "@/components/SearchComponent/UnbxdComponents/UnbxdAsideFilters/components/UnbxdTextSearch/UnbxdTextSearch";
import SearchCategories from "@/pages/homePageV2/homePageComponents/components/SearchCategories/SearchCategories";
import SearchByMake from "@/pages/homePageV2/homePageComponents/components/SearchByMake/SearchByMake";
import SearchByRangeContainer from "@/pages/homePageV2/homePageComponents/components/SearchByRangeContainer/SearchByRangeContainer";
import RecommendationSlider from "@/pages/homePageV2/homePageComponents/components/recommendation/RecommendationSlider";
import UnbxdMobileTextSearch from "@/components/SearchComponent/UnbxdComponents/UnbxdAsideFilters/components/UnbxdTextSearch/UnbxdMobileTextSearch/UnbxdMobileTextSearch";
import UspsSection from "@/pages/homePageV2/homePageComponents/components/Usps/UspsSection";
import HowToBuySection from "@/pages/homePageV2/homePageComponents/components/HowToBuy/HowToBuySection";
import Container from "@/components/sharedComponents/container/Container";
import DealsSection from "@/pages/homePageV2/homePageComponents/components/DealsSection/DealsSection";
import InstallmentSection from "@/pages/homePageV2/homePageComponents/components/InstallmentSection/InstallmentSection";
import { useMemo } from "react";
var fallback = {
  fallback: null
};
var SuggestionsContainerOnline = loadable({
  resolved: {},
  chunkName: function chunkName() {
    return "SuggestionsContainerOnline-SuggestionsContainerOnline";
  },
  isReady: function isReady(props) {
    var key = this.resolve(props);
    if (this.resolved[key] !== true) {
      return false;
    }
    if (typeof __webpack_modules__ !== 'undefined') {
      return !!__webpack_modules__[key];
    }
    return false;
  },
  importAsync: function importAsync() {
    return import(/* webpackChunkName: "SuggestionsContainerOnline-SuggestionsContainerOnline" */"../SuggestionsContainerOnline/SuggestionsContainerOnline");
  },
  requireAsync: function requireAsync(props) {
    var _this = this;
    var key = this.resolve(props);
    this.resolved[key] = false;
    return this.importAsync(props).then(function (resolved) {
      _this.resolved[key] = true;
      return resolved;
    });
  },
  requireSync: function requireSync(props) {
    var id = this.resolve(props);
    if (typeof __webpack_require__ !== 'undefined') {
      return __webpack_require__(id);
    }
    return eval('module.require')(id);
  },
  resolve: function resolve() {
    if (require.resolveWeak) {
      return require.resolveWeak("../SuggestionsContainerOnline/SuggestionsContainerOnline");
    }
    return eval('require.resolve')("../SuggestionsContainerOnline/SuggestionsContainerOnline");
  }
}, fallback);
var OffersWrapper = loadable({
  resolved: {},
  chunkName: function chunkName() {
    return "components-OfferCars-OffersWrapperV2";
  },
  isReady: function isReady(props) {
    var key = this.resolve(props);
    if (this.resolved[key] !== true) {
      return false;
    }
    if (typeof __webpack_modules__ !== 'undefined') {
      return !!__webpack_modules__[key];
    }
    return false;
  },
  importAsync: function importAsync() {
    return import(/* webpackChunkName: "components-OfferCars-OffersWrapperV2" */"./components/OfferCars/OffersWrapperV2");
  },
  requireAsync: function requireAsync(props) {
    var _this = this;
    var key = this.resolve(props);
    this.resolved[key] = false;
    return this.importAsync(props).then(function (resolved) {
      _this.resolved[key] = true;
      return resolved;
    });
  },
  requireSync: function requireSync(props) {
    var id = this.resolve(props);
    if (typeof __webpack_require__ !== 'undefined') {
      return __webpack_require__(id);
    }
    return eval('module.require')(id);
  },
  resolve: function resolve() {
    if (require.resolveWeak) {
      return require.resolveWeak("./components/OfferCars/OffersWrapperV2");
    }
    return eval('require.resolve')("./components/OfferCars/OffersWrapperV2");
  }
}, fallback);
var RatingSection = loadable({
  resolved: {},
  chunkName: function chunkName() {
    return "components-RatingSection-RatingSectionV2";
  },
  isReady: function isReady(props) {
    var key = this.resolve(props);
    if (this.resolved[key] !== true) {
      return false;
    }
    if (typeof __webpack_modules__ !== 'undefined') {
      return !!__webpack_modules__[key];
    }
    return false;
  },
  importAsync: function importAsync() {
    return import(/* webpackChunkName: "components-RatingSection-RatingSectionV2" */"./components/RatingSection/RatingSectionV2");
  },
  requireAsync: function requireAsync(props) {
    var _this = this;
    var key = this.resolve(props);
    this.resolved[key] = false;
    return this.importAsync(props).then(function (resolved) {
      _this.resolved[key] = true;
      return resolved;
    });
  },
  requireSync: function requireSync(props) {
    var id = this.resolve(props);
    if (typeof __webpack_require__ !== 'undefined') {
      return __webpack_require__(id);
    }
    return eval('module.require')(id);
  },
  resolve: function resolve() {
    if (require.resolveWeak) {
      return require.resolveWeak("./components/RatingSection/RatingSectionV2");
    }
    return eval('require.resolve')("./components/RatingSection/RatingSectionV2");
  }
}, fallback);
var AnyQust = loadable({
  resolved: {},
  chunkName: function chunkName() {
    return "components-AnyQust-AnyQustV2";
  },
  isReady: function isReady(props) {
    var key = this.resolve(props);
    if (this.resolved[key] !== true) {
      return false;
    }
    if (typeof __webpack_modules__ !== 'undefined') {
      return !!__webpack_modules__[key];
    }
    return false;
  },
  importAsync: function importAsync() {
    return import(/* webpackChunkName: "components-AnyQust-AnyQustV2" */"./components/AnyQust/AnyQustV2");
  },
  requireAsync: function requireAsync(props) {
    var _this = this;
    var key = this.resolve(props);
    this.resolved[key] = false;
    return this.importAsync(props).then(function (resolved) {
      _this.resolved[key] = true;
      return resolved;
    });
  },
  requireSync: function requireSync(props) {
    var id = this.resolve(props);
    if (typeof __webpack_require__ !== 'undefined') {
      return __webpack_require__(id);
    }
    return eval('module.require')(id);
  },
  resolve: function resolve() {
    if (require.resolveWeak) {
      return require.resolveWeak("./components/AnyQust/AnyQustV2");
    }
    return eval('require.resolve')("./components/AnyQust/AnyQustV2");
  }
}, fallback);
var FAQ = loadable({
  resolved: {},
  chunkName: function chunkName() {
    return "components-FAQ-FAQ";
  },
  isReady: function isReady(props) {
    var key = this.resolve(props);
    if (this.resolved[key] !== true) {
      return false;
    }
    if (typeof __webpack_modules__ !== 'undefined') {
      return !!__webpack_modules__[key];
    }
    return false;
  },
  importAsync: function importAsync() {
    return import(/* webpackChunkName: "components-FAQ-FAQ" */"./components/FAQ/FAQ");
  },
  requireAsync: function requireAsync(props) {
    var _this = this;
    var key = this.resolve(props);
    this.resolved[key] = false;
    return this.importAsync(props).then(function (resolved) {
      _this.resolved[key] = true;
      return resolved;
    });
  },
  requireSync: function requireSync(props) {
    var id = this.resolve(props);
    if (typeof __webpack_require__ !== 'undefined') {
      return __webpack_require__(id);
    }
    return eval('module.require')(id);
  },
  resolve: function resolve() {
    if (require.resolveWeak) {
      return require.resolveWeak("./components/FAQ/FAQ");
    }
    return eval('require.resolve')("./components/FAQ/FAQ");
  }
}, fallback);
var HomePage = function HomePage(props) {
  var _props$data, _installment_ranges$p, _dealItemsPosition1$p;
  var _useTranslation = useTranslation(["web_home"]),
    t = _useTranslation.t;
  var _useHelpers = useHelpers(),
    createUrl = _useHelpers.createUrl;
  var _ref = props.data,
    makes = _ref.makes,
    userFeedback = _ref.userFeedback,
    faqs = _ref.faqs,
    deals = _ref.deals,
    mixedPosts = _ref.all_posts,
    hot_deals = _ref.hot_deals,
    installment_ranges = _ref.installment_ranges;
  var isMobile = useIsMobile();
  var dealItemsPosition1 = useMemo(function () {
    var deal = hot_deals === null || hot_deals === void 0 ? void 0 : hot_deals.find(function (item) {
      return item.position === 1;
    });
    return deal !== null && deal !== void 0 ? deal : null;
  }, []);
  var dealItemPosition2 = useMemo(function () {
    var deal = hot_deals === null || hot_deals === void 0 ? void 0 : hot_deals.find(function (item) {
      return item.position === 2;
    });
    return deal !== null && deal !== void 0 ? deal : null;
  }, []);
  var isRecommendationsEnabled = checkFeatureFlag("FF_RECOMMENDATION_ENABLED");
  var _useRecentlyViewedCon = useRecentlyViewedContext(),
    renderRecentlyViewedCars = _useRecentlyViewedCon.renderRecentlyViewedCars;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h1", {
    className: "hide"
  }, t("سيارات للبيع في السعودية", {
    ns: "web_home"
  })), /*#__PURE__*/React.createElement(HomeBanner, {
    heros: props === null || props === void 0 ? void 0 : (_props$data = props.data) === null || _props$data === void 0 ? void 0 : _props$data.heros_area_v2
  }), /*#__PURE__*/React.createElement("div", {
    className: "lg:pb-[52px]"
  }, /*#__PURE__*/React.createElement("div", {
    className: "mx-auto max-w-[958px] rounded-[9px] bg-white shadow-[0_0_10px_rgba(188,188,188,0.4)] p-8 relative z-[99] mt-[-65px] max-md:mt-4 max-md:shadow-none max-md:px-4 max-md:py-0"
  }, !isMobile && /*#__PURE__*/React.createElement(UnbxdTextSearch, {
    customClass: "!w-full !max-w-full !m-0",
    setPage: null,
    referral_location: "main_area"
  }), isMobile && /*#__PURE__*/React.createElement(UnbxdMobileTextSearch, {
    referral_location: "main_area"
  }), /*#__PURE__*/React.createElement(SearchCategories, null), /*#__PURE__*/React.createElement(SearchByMake, {
    carMakes: makes
  }))), isMobile && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(LazyLoadComponent, {
    loadComponent: function loadComponent() {
      return /*#__PURE__*/React.createElement(SearchByRangeContainer, props);
    }
  })), renderRecentlyViewedCars(), installment_ranges && (installment_ranges === null || installment_ranges === void 0 ? void 0 : (_installment_ranges$p = installment_ranges.posts) === null || _installment_ranges$p === void 0 ? void 0 : _installment_ranges$p.length) > 0 && /*#__PURE__*/React.createElement("div", {
    className: "lg:mt-0 lg:pb-[52px]"
  }, /*#__PURE__*/React.createElement(InstallmentSection, {
    referral_location: "home",
    installmentData: installment_ranges
  })), isRecommendationsEnabled && /*#__PURE__*/React.createElement("div", {
    className: "lg:py-[52px]"
  }, /*#__PURE__*/React.createElement(RecommendationSlider, null)), /*#__PURE__*/React.createElement("div", {
    className: "lg:py-[52px]"
  }, /*#__PURE__*/React.createElement(UspsSection, null)), dealItemsPosition1 && (dealItemsPosition1 === null || dealItemsPosition1 === void 0 ? void 0 : (_dealItemsPosition1$p = dealItemsPosition1.posts) === null || _dealItemsPosition1$p === void 0 ? void 0 : _dealItemsPosition1$p.length) > 0 && /*#__PURE__*/React.createElement("div", {
    className: "mt-6 lg:mt-0 lg:py-[52px]"
  }, /*#__PURE__*/React.createElement(DealsSection, {
    posts: dealItemsPosition1 === null || dealItemsPosition1 === void 0 ? void 0 : dealItemsPosition1.posts,
    ctaLink: dealItemsPosition1 !== null && dealItemsPosition1 !== void 0 && dealItemsPosition1.deal_id ? createUrl("/deal/".concat(dealItemsPosition1 === null || dealItemsPosition1 === void 0 ? void 0 : dealItemsPosition1.deal_id)) : "",
    sectionTitle: dealItemsPosition1 === null || dealItemsPosition1 === void 0 ? void 0 : dealItemsPosition1.title,
    sectionVariant: "orange",
    sectionType: "marketing_carousel1",
    ctaId: dealItemsPosition1 !== null && dealItemsPosition1 !== void 0 && dealItemsPosition1.deal_id ? "homepage_deals-".concat(dealItemsPosition1 === null || dealItemsPosition1 === void 0 ? void 0 : dealItemsPosition1.deal_id) : ""
  })), /*#__PURE__*/React.createElement("div", {
    className: "mt-8 mb-2 lg:my-0 lg:py-[52px]"
  }, /*#__PURE__*/React.createElement(HowToBuySection, null)), mixedPosts && /*#__PURE__*/React.createElement(LazyLoadComponent, {
    loadComponent: function loadComponent() {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: "lg:py-[52px]"
      }, /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(SuggestionsContainerOnline, {
        title: t("سيارات للبيع في السعودية", {
          ns: "web_home"
        }),
        similarPosts: mixedPosts,
        btnTxt: t("شاهد جميع السيارات", {
          ns: "web_home"
        })
      }))));
    }
  }), dealItemPosition2 && dealItemPosition2.posts.length > 0 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "mt-6 lg:my-0 lg:py-[52px]"
  }, /*#__PURE__*/React.createElement(DealsSection, {
    posts: dealItemPosition2 === null || dealItemPosition2 === void 0 ? void 0 : dealItemPosition2.posts,
    ctaLink: dealItemPosition2 !== null && dealItemPosition2 !== void 0 && dealItemPosition2.deal_id ? createUrl("/deal/".concat(dealItemPosition2 === null || dealItemPosition2 === void 0 ? void 0 : dealItemPosition2.deal_id)) : "",
    sectionTitle: dealItemPosition2 === null || dealItemPosition2 === void 0 ? void 0 : dealItemPosition2.title,
    sectionVariant: "blue",
    sectionType: "marketing_carousel2",
    ctaId: dealItemsPosition1 !== null && dealItemsPosition1 !== void 0 && dealItemsPosition1.deal_id ? "homepage_deals-".concat(dealItemsPosition1 === null || dealItemsPosition1 === void 0 ? void 0 : dealItemsPosition1.deal_id) : ""
  }))), deals && /*#__PURE__*/React.createElement(LazyLoadComponent, {
    loadComponent: function loadComponent() {
      return /*#__PURE__*/React.createElement("div", {
        className: !isMobile ? stl.CustomContainer : undefined
      }, /*#__PURE__*/React.createElement(OffersWrapper, {
        deals: deals,
        title: t("تصنيفات مميزة", {
          ns: "web_home"
        })
      }));
    }
  }), /*#__PURE__*/React.createElement(LazyLoadComponent, {
    renderOnSSR: false,
    loadComponent: function loadComponent() {
      return /*#__PURE__*/React.createElement(RatingSection, {
        data: userFeedback
      });
    }
  }), /*#__PURE__*/React.createElement(LazyLoadComponent, {
    loadComponent: function loadComponent() {
      return /*#__PURE__*/React.createElement(FAQ, {
        faqs: faqs,
        isHomePage: true
      });
    }
  }), !isMobile && /*#__PURE__*/React.createElement(LazyLoadComponent, {
    loadComponent: function loadComponent() {
      return /*#__PURE__*/React.createElement(AnyQust, null);
    }
  }));
};
export default HomePage;